module.exports = __webpack_public_path__ + "img/management-share-2.d84913eb.png";